import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { Alert } from 'src/app/shared/models/Alert';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { saveAs } from 'file-saver';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipDirective } from '../../../directives/tooltip.directive';
import { SearchPipe } from '../../../pipes/search.pipe';
@Component({
    selector: 'app-list-users',
    templateUrl: './list-users.component.html',
    styleUrl: './list-users.component.css',
    imports: [
        CommonModule,
        FormsModule,
        TooltipDirective,
        SearchPipe
    ]
})
export class ListUsersComponent {
  users: UserDTO[] = [];
  filterValue: string = 'option1';
  currentPage: number = 1;
  totalPages: number = 0;
  pagesToShow: number = 5;
  textoBusqueda: string = '';
  camposBusqueda: string[] = [
    'userId',
    'userNames',
    'userMail',
    'userPhone',
    'numberPlans',
    'numberDevices',
  ];
  isFilteredByStatus: boolean = false;
  originalCustomers: any[] = [];
  selectedCustomer: any;
  recordsPerPage: number = 10;
  alert: Alert = {} as Alert;

  constructor(
    private customerService: CustomerService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService
  ) {}

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.UserManagement);
    this.customerService.getListUsersManagement().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleGetListCustomers(Data);
        } else {
          this.HandleGetListCustomersError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );
  }

  get pages(): number[] {
    const start = Math.max(
      1,
      this.currentPage - Math.floor(this.pagesToShow / 2)
    );
    const end = Math.min(this.totalPages, start + this.pagesToShow - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage() {
    if (this.currentPage * this.recordsPerPage < this.users.length) {
      this.currentPage++;
    }
  }

  getRange(): string {
    const startIndex = (this.currentPage - 1) * this.recordsPerPage + 1;
    const endIndex = Math.min(
      this.currentPage * this.recordsPerPage,
      this.users.length
    );
    return `${startIndex} - ${endIndex}`;
  }

  HandleGetListCustomersError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  HandleGetListCustomers(customer: UserDTO[]) {
    this.users = customer;
    this.originalCustomers = this.users.slice();
    this.users = this.originalCustomers.filter(
      (user) => user.userStatus === 0 || user.userStatus === 1
    );
    this.totalPages = Math.ceil(this.users.length / this.recordsPerPage);
  }

  updatePagination(): void {
    const filteredList = this.users.filter((customer: UserDTO) =>
      this.camposBusqueda.some((campo: string) =>
        (customer as any)[campo]
          .toString()
          .toLowerCase()
          .includes(this.textoBusqueda.toLowerCase())
      )
    );

    this.currentPage = 1;
    this.totalPages = Math.ceil(filteredList.length / this.recordsPerPage);
  }

  onSearchChange(): void {
    this.updatePagination();
  }

  filterByStatus(status: number) {
    this.users = this.originalCustomers.slice(); // Restaura la lista original
    if (!this.isFilteredByStatus) {
      // Guarda la lista original si no se ha filtrado aún
      this.originalCustomers = this.users.slice();
      this.isFilteredByStatus = true;
    }

    this.users = this.originalCustomers.filter(
      (customer) => customer.userStatus === status
    );
    //console.log(this.users);
    this.updatePagination();
  }

  clearFilter() {
    this.isFilteredByStatus = false;
    this.users = this.originalCustomers.slice(); // Restaura la lista original
    this.users = this.users.filter(
      (user) => user.userStatus === 0 || user.userStatus === 1
    );
    this.updatePagination();
  }

  setSelectedCustomer(customer: any) {
    this.selectedCustomer = customer;
  }

  setArchivedCustomer(customer: any) {
    this.selectedCustomer = customer;
    //this.selectedCustomer.userStatus = 2;
    this.selectedCustomer['@userStatus'] = this.isFilteredByStatus ? 1 : 2;
    //console.log(this.selectedCustomer);
  }

  toggleStatus(event: any, customer: any) {
    customer.userStatus = event.target.checked ? 1 : 0;
    const indice = this.originalCustomers.findIndex(
      (cust) => cust.userId === customer.userId
    );
    if (indice !== -1) {
      this.originalCustomers[indice].userStatus = customer.userStatus;
    }
  }

  openConfirmationModal(customer: any) {
    this.selectedCustomer = customer;
  }

  updateUserStatus(confirmed: boolean) {
    if (confirmed) {
      if (typeof this.selectedCustomer['@userStatus'] === 'number') this.selectedCustomer.userStatus = this.selectedCustomer['@userStatus'];
      this.customerService
        .updateCustomerStatus(this.selectedCustomer)
        .subscribe(
          ({ StatusCode, Message, Data }) => {
            if (Data != null) {
              this.HandleUpdateCustomerStatus(Data);
            } else {
              this.HandleUpdateCustomerStatusError(StatusCode);
            }
          },
          (error) => {
            this.alert = {
              alertMessage: 'Unexpected error. Please try again later.',
              alertType: 'alert alert-danger',
              alertCenter: false,
              alerTitle: '',
              duration: 3000
            };
            this.alertService.updateAlertState(
              this.alert
            );
          }
        );
    } else {
      location.reload();
    }
  }

  HandleUpdateCustomerStatusError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  async HandleUpdateCustomerStatus(customer: boolean) {
		this.alert = {
      alertMessage: 'Customer status updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
    location.reload();
  }

  navigateToUpdateUser(user: any) {
    this.router.navigate(['/user-management/update-user-management', user.userId]);
  }

  navigateToCreateUser() {
    this.router.navigate(['/user-management/create-user']);
  }

  //Este metodo se ejecuta cuando se presiona el boton de regresar
  goBack() {
    //Se redirecciona a la ruta /home
    window.location.href = '/home';
  }

  navigateToCustomerView(customer: any) {
    //console.log('navigate to customer view');
    //console.log(customer);
    this.router.navigate(['/user-management/view-users', customer.userId]);
  }

  exportListPartnersToExcel() {
    this.customerService.exportToExcelListUsersManagement().subscribe(
      (response: ResponseDataFile) => {
        if (response) {
          this.handleDownload(response);
        } else {
          this.handleGetFileError();
        }
      },
      (error) => {
        console.error('Error al exportar el archivo Excel:', error);
      }
    );
  }

  private handleDownload(data: ResponseDataFile) {
    const byteCharacters = atob(data.Data.fileContents);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.Data.contentType });
    saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

		this.alert = {
      alertMessage: 'File generated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
  }

  private handleGetFileError() {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }
}
